import { useState } from "react";
import useS3Url from "../hooks/useS3Url";

const ImageWithSkeleton = ({ src, alt, className, style, classNameInIMage, noRounded = false, isBlog }) => {
    const [loading, setLoading] = useState(true);
    const resolvedSrc = useS3Url(src);
    return (
        <div className={`relative ${className}`} style={style}>
            {loading && (
                <div
                    className={`absolute inset-0 bg-gray-200 animate-pulse ${noRounded ? '' : 'rounded-lg'}`}
                    style={style}
                ></div>
            )}
            <img
                src={resolvedSrc || undefined}
                alt={alt}
                style={{ ...style, opacity: loading ? 0 : 1, transition: "opacity 0.3s" }}
                onLoad={() => setLoading(false)}
                className={classNameInIMage}
            />
        </div>
    );
};

export default ImageWithSkeleton;
